import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { computeSafeSpawnPosition } from './spawnHelper';

export const WeaponMolotov: WeaponDefinition = {
  id: 'molotov',
  name: 'Petrol Bomb',
  icon: 'petrolbm.1.png',
  category: 'thrown',
  maxAmmo: -1,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const maxSpeed = 750;
    const speed = (power / 100) * maxSpeed;
    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;

    const spawnDistance = 20;
    const spawn = computeSafeSpawnPosition(worm, aimRad, spawnDistance, world);

    const molotov = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'molotov',
      timer: -1,
      bounceH: 0,
      bounceV: 0,
      windAffected: false,
      explosionRadius: 20,
      maxDamage: 15,
      ownerId: worm.id,
    });

    return {
      success: true,
      entities: [molotov],
    };
  },
};
